import { render, staticRenderFns } from "./addKeyword.vue?vue&type=template&id=54db85aa&"
import script from "./addKeyword.vue?vue&type=script&lang=js&"
export * from "./addKeyword.vue?vue&type=script&lang=js&"
import style0 from "./addKeyword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports